// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1U7su","title":"Header_title__2g1xs","left":"Header_left__34EX4","clinicName":"Header_clinicName__1h4od"};